export const constants = {
  STORY_COUNT: 10,
  TRANSITION_TIME: 1,
  DESIGN_COLOR: '#992AC0',
  ENGINEERING_COLOR: '#3E54A5',
  BUSINESS_COLOR: '#96FFC5',
  BUSINESS_COLOR_LIGHT: '#17452D',
  PUBLIC_RESUME_LINK:
    'https://doixzan7hf4ti.cloudfront.net/resumes/JustinZhangResume2022.pdf',
  EMAIL: 'justinzhangzll@gmail.com',
  LINKEDIN_LINK: 'https://linkedin.com/in/justinzhang000',
  CLOUDFRONT_LINK: 'https://doixzan7hf4ti.cloudfront.net',
  GITHUB_REPO: 'https://github.com/justinnzhang/wrapped',
};
